const URL = {
  APPSUMO_CODE_REFUND: 'promoCode/refundPromoCode',
}

export default URL
